// プラグイン
import 'slick-carousel';
// js
import './js/index.js';
import '../../common/js/common.js';
// スタイルシート
import './scss/style.scss';
